module.exports = __webpack_public_path__ + "img/E-WEB-Goal-16.aefc84d0.svg";